"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsSettingsSidebar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const react_router_dom_1 = require("react-router-dom");
const translations_1 = require("../../../features/NotificationsSettings/types/translations");
const trackingIds = {
    preferencesItem: 'notification_settings-sidebar_preferences_button',
    settingsItem: 'notification_settings-sidebar_settings_button',
};
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    container: {
        background: theme.palette.background.paper,
    },
}));
const NotificationsSettingsSidebar = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const classes = useStyles();
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const isRouteItemActive = ({ href }) => {
        return !!(0, react_router_dom_1.matchPath)(location.pathname, {
            path: href,
        });
    };
    const prefsHref = '/notification-center/settings/preferences';
    const advancedHref = '/notification-center/settings/advanced';
    return ((0, jsx_runtime_1.jsxs)(silhouette_core_1.Sidebar, { open: true, variant: "permanent", position: "relative", classes: { paper: classes.container }, children: [(0, jsx_runtime_1.jsx)(silhouette_core_1.SidebarItemLink, { to: prefsHref, replace: true, icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: " " }), label: translate(translations_1.sidebarTranslations.preferences), showLabel: true, selected: isRouteItemActive({ href: prefsHref }), "data-tracking-id": trackingIds.preferencesItem }), (0, jsx_runtime_1.jsx)(silhouette_core_1.SidebarItemLink, { to: advancedHref, replace: true, icon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: " " }), label: translate(translations_1.sidebarTranslations.settings), showLabel: true, selected: isRouteItemActive({ href: advancedHref }), "data-tracking-id": trackingIds.settingsItem })] }));
};
exports.NotificationsSettingsSidebar = NotificationsSettingsSidebar;
//# sourceMappingURL=NotificationSettingsSidebar.js.map